<template>
  <div class="question">
    <header class="question__header">
      <p class="question__title">{{ title }}</p>
    </header>
    <div class="question__body" :class="{isLong:testType == 'exam'}">
      <div class="question__no">
        <span>{{ questionId }}</span> / <span>{{ questionNum }}</span>
      </div>
      <div class="question__text">
        <VuePerfectScrollbar class="scroll-area" v-bind:settings="settings" tagname="div" ref="ps">
          <template v-if="testType == 'study'">
            <p>{{ questionText }}</p>
          </template>
          <template v-else-if="testType == 'exam'">
            <p>{{ questionText }}</p>
            <p v-if="questionImage">
              <img :src="`${staticPath}img/factory/test/question/${testType}_${testId}_${questionId}.png`">
            </p>
          </template>
        </VuePerfectScrollbar>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/modules.scss';

  .question__header {
    position: relative;
    z-index: 10;
    padding: 0 20px;
  }
  
  .question__title {
    padding: 6px;
    color: #fff;
    background-color: #1c3a88;
    border-radius: 12px;
    text-align: center;
    font-size: 1.4rem;
    font-weight: 700;
  }

  .question__body {
    position: relative;
    height: 180px;
    margin-top: -15px;
    padding: 25px 20px 20px;
    padding-right: 10px;
    background-color: #fff;
    border-radius: 10px;

    &.isLong {
      height: 240px;

      @include mq_sp_s {
        height: 180px;
      }
    }
  }

  .question__no {
    width: 120px;
    margin: 0 auto;
    padding: 5px;
    color: #1c3a88;
    background-color: #e9e9e9;
    border-radius: 10px;
    text-align: center;
    font-size: 1.5rem;
    font-weight: 700;
  }

  .question__text {
    height: calc(100% - 15px);
    padding-top: 10px;
    font-size: 1.5rem;
    line-height: 1.6;
    

    p {
      white-space: pre-line;
    }

    img {
      display: inline-block;
      padding-top: 10px;
    }
  }

  .scroll-area {
    height: 100%;
    padding-right: 10px;
  }
</style>

<style lang="scss">
  @import '@/assets/scss/_scrollbar.scss';
</style>

<script>
import Constant from '@/constant';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'QuestionText',
  props: ['testType', 'testId', 'title', 'questionId', 'questionNum', 'questionText', 'questionImage'],

  components: {
    VuePerfectScrollbar
  },

  data(){
    return {
      staticPath: Constant.STATICPATH,
      settings: {
        suppressScrollX: true,
        swipeEasing: false
      },
    }
  },

  mouted() {

    var ps = this.$refs.ps;
    ps.update();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Study/Parts/QuestionText.vue